import { Formik, FormikErrors } from 'formik';

import { AddressMessage } from '../../../../../types/AddressMessage';
import { translate } from '../../../../common/helpers/translate.helper';

import { FormikCreateSupplierCompanyForm } from './FormikCreateSupplierCompanyForm';

export interface FormikSupplierCreateState {
    name: string;
    internalName?: string;
    email: string;
    phone?: string;
    fax?: string;
    invoiceMail: string;
    address: AddressMessage;
    testCompany: boolean;
    showGtc: boolean;
    trial: boolean;
    messageSettings: {
        oderConfirmationMessage: string;
        quotationMessage: string;
    };
}

export interface CreateSupplierCompanyFormProps {
    onSubmit: (values: FormikSupplierCreateState) => void;
}

export const CreateSupplierCompanyForm = ({ onSubmit }: CreateSupplierCompanyFormProps) => {
    const initialFormikState: FormikSupplierCreateState = {
        name: '',
        internalName: '',
        email: '',
        phone: '',
        fax: '',
        invoiceMail: '',
        address: {
            city: '',
            companyName: '',
            country: '',
            street: '',
            streetNumber: '',
            zipcode: '',
        },
        testCompany: true,
        showGtc: false,
        trial: false,
        messageSettings: {
            oderConfirmationMessage: '',
            quotationMessage: '',
        },
    };

    const validate = (values: FormikSupplierCreateState) => {
        const errors: FormikErrors<FormikSupplierCreateState> = {};

        if (!values.name) {
            errors.name = translate('supplier.noCompanyNameError');
        }

        if (!values.email) {
            errors.email = translate('supplier.noEmailAddressError');
        }

        return errors;
    };

    return (
        <Formik
            initialValues={initialFormikState}
            onSubmit={onSubmit}
            validate={validate}
            component={FormikCreateSupplierCompanyForm}
        />
    );
};
